
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import FormModelDisplay from '@/components/FormModelDisplay.vue';
import EmbeddedForm from '@/util/form/EmbeddedForm';
import NavigationItemTranslationRepository from '@/repositories/sidebar/NavigationItemTranslationRepository';
import NavigationItemRepository from '@/repositories/sidebar/NavigationItemRepository';
import SubNavigationItemRepository from '@/repositories/sidebar/SubNavigationItemRepository';
import SubNavigationItemTranslationRepository from '@/repositories/sidebar/SubNavigationItemTranslationRepository';

@Component({
    components: {
        GeneralScaffold,
        FormModelDisplay,
    },
})
export default class NavigationListScreen extends Vue {
    @Inject()
    private readonly navigationItemRepository!: NavigationItemRepository;

    @Inject()
    private readonly navigationItemTranslationRepository!: NavigationItemTranslationRepository;

    @Inject()
    private readonly subNavigationItemRepository!: SubNavigationItemRepository;

    @Inject()
    private readonly subNavigationItemTranslationRepository!: SubNavigationItemTranslationRepository;

    private get embeds(): EmbeddedForm[] {
        return [
            {
                relationship: 'translations',
                parentRefKey: 'navigationItemId',
                i18nGroup: 'navigationItemTranslation',
                entityRepository: this.navigationItemTranslationRepository,
                columns: ['lang', 'name'],
            },
            {
                relationship: 'subNavigationItems',
                parentRefKey: 'navigationItemId',
                i18nGroup: 'subNavigationItem',
                entityRepository: this.subNavigationItemRepository,
                columns: ['defaultName', 'order'],
                embeds: [
                    {
                        relationship: 'translations',
                        parentRefKey: 'subNavigationItemId',
                        i18nGroup: 'subNavigationItemTranslation',
                        entityRepository: this.subNavigationItemTranslationRepository,
                        columns: ['lang', 'name'],
                    },
                    {
                        relationship: 'order',
                        parentRefKey: 'navigationItemId',
                        i18nGroup: 'subNavigationItem',
                        entityRepository: this.subNavigationItemRepository,
                        columns: ['defaultName'],
                    },
                ],
            },
            {
                relationship: 'order',
                parentRefKey: 'navigationItemId',
                i18nGroup: 'navigationItem',
                entityRepository: this.navigationItemRepository,
                columns: ['defaultName'],
            },
        ];
    }
}
